import type { IFieldDefinition } from '@platform/core/types';
import type { ISubTableDef } from './ISubTableDef';

/** Типове значення поля нового рядка (прототип onAdd: вибір — перший варіант, особа — я; обов'язкова дата поза колонками — сьогодні). */
const defaultOf = (f: IFieldDefinition, meId: string | undefined, today: string, column: boolean): unknown => {
  if (f.type === 'select' && f.options?.length) return f.options[0]?.value;
  if (f.type === 'user') return meId ?? null;
  if (!column && f.type === 'date') return today;
  if (!column && f.type === 'boolean') return false;
  return null;
};

/**
 * Значення нового рядка підтаблиці (прототип v4 SUB_DEFS onAdd): посилання на батьківський запис, колонки — вибір першим варіантом (статус —
 * початковим статусом типу), особа — поточним користувачем, решта порожні; обов'язкові поля поза колонками отримують ті самі типові
 * значення (дата — сьогодні, так/ні — ні), щоб рядок можна було зберегти. Порожні значення не надсилаються. Чиста функція.
 */
export function subTableDefaults(def: ISubTableDef, parentId: string, meId: string | undefined, today: string): Record<string, unknown> {
  const out: Record<string, unknown> = { [def.lookup.key]: parentId };
  const columns = new Set(def.columns.map((f) => f.key));
  const initial = def.child.statuses.initial ?? def.child.statuses.list[0]?.value;
  if (columns.has('status') && initial) out['status'] = initial;
  for (const f of def.child.fields) {
    if (f.key === def.lookup.key || f.key === 'title' || f.key === 'status' || (!columns.has(f.key) && !f.required)) continue;
    const value = defaultOf(f, meId, today, columns.has(f.key));
    if (value !== null && value !== undefined) out[f.key] = value;
  }
  return out;
}
